import { serviceRequest } from 'utils/http';
import { ReferralService } from 'common/api';

export function getReferralSiteTimezoneAPI(id: string) {
  return serviceRequest(() =>
    ReferralService.referralControllerGetSiteTimeZoneCurrentUser(id)
  );
}
